import updateSelectedLogIndex from '../mutators/updateSelectedLogIndex';
import { CalendarNotificationUpdateLog } from '../store/schema/CalendarNotificationDiagnosticsStore';
import getStore from '../store/store';
import { observer } from 'mobx-react';
import { Button } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { formatUserDateTime } from 'owa-datetime';
import * as React from 'react';
import { Inspector } from 'react-inspector';
import {
    DetailsList,
    Selection,
    SelectionMode,
} from 'office-ui-fabric-react/lib/components/DetailsList';
import {
    copyToClipboard,
    createCopyEventListener,
} from 'owa-diagnostics/lib/utils/copyToClipboardUtils';

const styles = require('./CalendarNotificationDiagnosticsPanel.scss');

@observer
export default class CalendarNotificationDiagnosticsPanel extends React.Component<{}> {
    private selection: Selection;
    private copyEventListener: (e: ClipboardEvent) => void;

    constructor(props: any) {
        super(props);
        this.selection = new Selection({
            selectionMode: SelectionMode.multiple,
            onSelectionChanged: () => {
                if (this.selection.getSelectedCount() == 1) {
                    updateSelectedLogIndex(Number(this.selection.getSelection()[0].key));
                }
            },
            canSelectItem: () => true,
            getKey: this.getKey,
        });
        this.copyEventListener = createCopyEventListener<CalendarNotificationUpdateLog>(
            () => getStore().notificationUpdateLogs.reverse(), // we reverse the list in the view, so we should reverse it here too
            [
                'timestamp',
                'message',
                'folderId',
                'notificationPayload',
                'notificationItem',
                'errorMessage',
            ]
        );
    }

    private getKey = item => item.key;

    componentDidMount() {
        document.addEventListener('copy', this.copyEventListener);
    }

    componentWillUnmount() {
        document.removeEventListener('copy', this.copyEventListener);
    }

    render() {
        const { notificationUpdateLogs, selectedLogIndex } = getStore();
        const logs = notificationUpdateLogs
            .map((log, index) => {
                const hasMoreDetails =
                    log.errorMessage || log.notificationPayload || log.notificationItem
                        ? 'true'
                        : 'false';
                return {
                    Timestamp: formatUserDateTime(log.timestamp),
                    Message: log.message,
                    FolderId: log.folderId,
                    HasMoreDetails: hasMoreDetails,
                    key: index,
                };
            })
            .reverse();

        return (
            <div>
                <Button onClick={copyToClipboard} className={styles.button}>
                    {'Copy all rows to clipboard'}
                </Button>
                <div className={styles.container}>
                    <div className={styles.table}>
                        <DetailsList
                            items={logs}
                            selection={this.selection}
                            selectionMode={SelectionMode.single}
                            setKey="CalendarNotifications"
                        />
                    </div>
                    {selectedLogIndex != -1 && (
                        <div className={styles.rightPanel}>
                            {this.renderObject(
                                notificationUpdateLogs[selectedLogIndex].timestamp,
                                'Timestamp'
                            )}
                            {this.renderObject(
                                notificationUpdateLogs[selectedLogIndex].message,
                                'Message'
                            )}
                            {this.renderObject(
                                notificationUpdateLogs[selectedLogIndex].folderId,
                                'FolderId'
                            )}
                            {this.renderObject(
                                notificationUpdateLogs[selectedLogIndex].notificationPayload,
                                'NotificationPayload'
                            )}
                            {this.renderObject(
                                notificationUpdateLogs[selectedLogIndex].notificationItem,
                                'NotificationItem'
                            )}
                            {this.renderObject(
                                notificationUpdateLogs[selectedLogIndex].errorMessage,
                                'ErrorMessage'
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private renderObject = (object: Object, title: string) => {
        return (
            <>
                <Label>{title}</Label>
                <Inspector data={object} />
            </>
        );
    };
}

export const renderPanel = () => <CalendarNotificationDiagnosticsPanel />;
